import styled from 'styled-components/macro';
import { device } from 'components/styles/MediaQuery';

export const ScEditCurrenciesModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 32px;

  .btn {
    display: flex;
    justify-content: center;
  }

  @media (${device.mobileS}) {
    width: 100%;
  }
`;

export const ScTitleEditCurrencies = styled.div`
  font-weight: 700;
  font-size: 22px;
  line-height: 1.27;
  text-align: center;
  letter-spacing: 0.01em;
  color: ${({ theme }) => theme.whiteColor};
`;

export const ScCurrenciesBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  & > .title {
    font-weight: 700;
    font-size: 16px;
    line-height: 1.25;
    letter-spacing: 0.01em;
    color: ${({ theme }) => theme.whiteColor};
    margin-left: 8px;
  }
`;
